import React from 'react';
import { useGoalsStep } from '../../hooks/useGoalsStep';
import { useIsMobile } from '../../hooks/useMediaQuery';
import type { Dispatch } from '../../hooks/useDietPlanBuilder';
import type { OccupiedRange } from '../../lib/planDates';
import type { Plan } from '../../types';
import { GoalsStepDesktop } from './GoalsStepDesktop';
import { GoalsStepMobile } from './GoalsStepMobile';

/**
 * Container: owns the single `useGoalsStep` instance and picks the presentation.
 * Breakpoint (< 768px) matches the CSS module's mobile media query.
 * Switching layouts never loses data: all state lives in the builder reducer.
 */
export function GoalsStep({
  plan,
  dispatch,
  occupied = [],
}: {
  plan: Plan;
  dispatch: Dispatch;
  occupied?: OccupiedRange[];
}) {
  const goals = useGoalsStep(plan, dispatch, occupied);
  const isMobile = useIsMobile();
  return isMobile ? <GoalsStepMobile g={goals} /> : <GoalsStepDesktop g={goals} />;
}
